import { render, staticRenderFns } from "./CardUpdateVideos.vue?vue&type=template&id=bf987548&scoped=true"
import script from "./CardUpdateVideos.vue?vue&type=script&lang=js"
export * from "./CardUpdateVideos.vue?vue&type=script&lang=js"
import style0 from "./CardUpdateVideos.vue?vue&type=style&index=0&id=bf987548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf987548",
  null
  
)

export default component.exports